import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getEoPSummary(buildingId: string, schoolYear: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.eopSummary.replace(':buildingId', buildingId);
            
    const params = new HttpParams().set('school_year', schoolYear);
    return this.http.get<{has_error: boolean, message: string, data: any}>(url, { params }).pipe(
        catchError(this.errorService.handleError)
    );
  }
}